import React from 'react';
import { Input, Grid, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import TableExcursionList from '../table/tableExcursionList';
import { HeaderTabelExcursion } from '../table/headerTabel';
import ButtonAction from '../common/ButtonGroupSupplier';
import HeaderTitle from '../common/headerTitle';
import Pagination from '../common/pagination';
const excursionList = props => (
  <div>
    <Grid columns="equal" style={{ marginTop: '30px' }}>
      <Grid.Row stretched>
        <Grid.Column>
          <Segment>
            <HeaderTitle title={props.title} />
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Input
                    icon="search"
                    placeholder="search"
                    name="searchInput"
                    value={props.searchInput}
                    onChange={props.handleChange}
                  />
                </Grid.Column>
                <Grid.Column width={12}>
                  <ButtonAction
                    buttonNew={props.buttonNew}
                    butttonExport={props.butttonExport}
                    buttonUploadData={props.buttonUploadData}
                    buttonDownloadTemplate={props.buttonDownloadTemplate}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <TableExcursionList
              data={props.data}
              headerTable={HeaderTabelExcursion}
              pageChange={props.pageChange}
              listData={props.listData}
              pagedData={props.pagedData}
              handleClickEdit={props.butttonEdit}
              handleClickDelete={props.buttonDelete}
            />
            <Pagination
              pagedData={props.pagedData}
              numbersTo={props.numbersTo}
              numbersFrom={props.numbersFrom}
              data={props.data}
              pageChange={props.pageChange}
              activePage={props.activePage}
            />
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

excursionList.propTypes = {
  listData: PropTypes.array,
  pagedData: PropTypes.array,
  title: PropTypes.string,
  pageChange: PropTypes.func,
  activePage: PropTypes.number,
  searchInput: PropTypes.string,
  handleChange: PropTypes.func,
  data: PropTypes.array,
  butttonEdit: PropTypes.func,
  buttonNew: PropTypes.func,
  butttonExport: PropTypes.func,
  buttonUploadData: PropTypes.func,
  buttonDownloadTemplate: PropTypes.func,
  buttonDelete: PropTypes.func,
  handleNewAccomodation: PropTypes.func,
  numbersFrom: PropTypes.number,
  numbersTo: PropTypes.number,
};
export default excursionList;
